__turbopack_context__.v({
  "icon": "geo-location-module-scss-module__q2_CSW__icon",
  "mini": "geo-location-module-scss-module__q2_CSW__mini",
});
